import React, { useState } from 'react';
import { connect } from 'react-redux';
import {
  AcceptButtonContainer,
  BoxContainer,
  BoxSelectLeadType,
  ContentContainer,
  CreateContainer,
  TitleContainer
} from './style';
import MainFont from '../../typography/mainFont';
import { Button } from 'ui/atoms';
import { useTranslation } from 'react-i18next';

import corp from 'ui/assets/img/corp_manager.png';
import person from 'ui/assets/img/person.png';
import inbox from 'ui/assets/img/inbox-emoji.png';
import PropTypes from 'prop-types';

const SelectLeadType = ({ setLeadType }) => {
  const { t } = useTranslation();

  const [selectedLeadType, setSelectedLeadType] = useState(null);

  return (
    <CreateContainer selectLead>
      <ContentContainer>
        <TitleContainer>
          <MainFont type="createAccountHeaders">
            {t('create_lead_type')}
          </MainFont>
        </TitleContainer>
        <BoxContainer>
          <BoxSelectLeadType
            onClick={() => setSelectedLeadType('b2b')}
            selectedType={selectedLeadType === 'b2b'}
          >
            <img src={corp} alt="emoji of corporation" />
            <MainFont type="leadCreationOptions">{t('business_lead')}</MainFont>
          </BoxSelectLeadType>
          <BoxSelectLeadType
            onClick={() => setSelectedLeadType('b2c')}
            selectedType={selectedLeadType === 'b2c'}
          >
            <img src={person} alt="emoji of person" />
            <MainFont type="leadCreationOptions">{t('private_lead')}</MainFont>
          </BoxSelectLeadType>
        </BoxContainer>
      </ContentContainer>
      <BoxSelectLeadType
        onClick={() => setSelectedLeadType('csv')}
        selectedType={selectedLeadType === 'csv'}
      >
        <img src={inbox} alt="emoji of inbox" />
        <MainFont type="leadCreationOptions">{t('lead_csv')}</MainFont>
      </BoxSelectLeadType>
      <AcceptButtonContainer>
        <Button
          variant="accept-button"
          onClick={() => {
            setLeadType(selectedLeadType);
          }}
          disabled={!selectedLeadType}
        >
          <MainFont type="addAccountLabels">{t('continue')}</MainFont>
        </Button>
      </AcceptButtonContainer>
    </CreateContainer>
  );
};

SelectLeadType.propTypes = {
  setLeadType: PropTypes.func
};

export default connect(null, null)(SelectLeadType);
